module.exports = __webpack_public_path__ + "static/media/the-lonesome-crowded-west.c98b7427.jpg";